import routerOptions0 from "/home/runner/work/evaluation/evaluation/node_modules/.pnpm/nuxt@3.21.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.35_eslint@9.39.4_less@4.6.4_sass-embed_37cefrshn5hmwgkrevl25vgqia/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}